var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuppliers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,30V50a.7502.7502,0,0,0,.75.75H50a.7502.7502,0,0,0,.75-.75V30a.7502.7502,0,0,0-.75-.75H30A.7502.7502,0,0,0,29.25,30Zm9.5.75h2.5v6.5h-2.5Zm-8,0h6.5v8h5.5v-8h6.5v18.5H30.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.53027,39.46973l-4-4-1.06054,1.06054L68.18945,39.25H56v1.5H68.18945l-2.71972,2.71973,1.06054,1.06054,4-4A.74972.74972,0,0,0,70.53027,39.46973Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.46973,44.53027l1.06054-1.06054L11.81055,40.75H24v-1.5H11.81055l2.71972-2.71973-1.06054-1.06054-4,4a.74972.74972,0,0,0,0,1.06054Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75,24V11.81055l2.71973,2.71972,1.06054-1.06054-4-4a.74972.74972,0,0,0-1.06054,0l-4,4,1.06054,1.06054L39.25,11.81055V24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,56V68.18945l-2.71973-2.71972-1.06054,1.06054,4,4a.74971.74971,0,0,0,1.06054,0l4-4-1.06054-1.06054L40.75,68.18945V56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.53027,24.53027,67.25,13.81055v3.84619h1.5V12a.7502.7502,0,0,0-.75-.75H62.34277v1.5h3.84668L55.46973,23.46973Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25,62.34326V68a.7502.7502,0,0,0,.75.75h5.65723v-1.5H13.81055L24.53027,56.53027l-1.06054-1.06054L12.75,66.18945V62.34326Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75,68V62.34326h-1.5v3.84619L56.53027,55.46973l-1.06054,1.06054L66.18945,67.25H62.34277v1.5H68A.7502.7502,0,0,0,68.75,68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65723,11.25H12a.7502.7502,0,0,0-.75.75v5.65674h1.5V13.81055L23.46973,24.53027l1.06054-1.06054L13.81055,12.75h3.84668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuppliers);
export default __webpack_public_path__ + "static/media/icon_suppliers.17a3837a41cbc03e00ed9351c4ada2a7.svg";
export { ForwardRef as ReactComponent };